import React, { Fragment } from "react";
import PropTypes from "prop-types";
import s from "./style.module.css";
import { Button, Modal } from "react-bootstrap";
import localization from "assets/localization/localization";
import Loader from "components/sales/Loader/loader";

const ModalPop = ({
  title = "title",
  children,
  show,
  footer = false,
  handleModalHide,
  keyboard = false,
  backdrop = false,
  footerCloseBtn = false,
  handleModalSubmit,
  footerSubmitTxt = null,
  isLoading = false,
  closeButton=true,
  modalSize="",
  headerClassName = "",
  titleClassName = "",
  centered = false,
  dialogClassName = "",
}) => {
  return (
    <Fragment>
      <Modal
      show={show}
      onHide={handleModalHide}
      keyboard={keyboard ? false : true}
      backdrop={backdrop ? "static" : true}
      dialogClassName={`${s.root} ${
        modalSize === "lg"
          ? s.root_lg
          : modalSize === "md"
            ? s.root_md
            : modalSize === "compact"
              ? s.root_compact
              : ""
      } ${dialogClassName}`.trim()}
      centered={centered}
      animation={false}
      scrollable
    >
      
      <Modal.Header closeButton={closeButton} className={headerClassName}>
        <Modal.Title className={titleClassName}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {footer ? (
        <Modal.Footer>
          {footerCloseBtn ? (
            <Button onClick={handleModalHide}>{localization.close}</Button>
          ) : null}
          <Button onClick={handleModalSubmit}>
            {footerSubmitTxt || localization.saveChanges}
          </Button>
        </Modal.Footer>
      ) : null}
    </Modal>
      <Loader isLoading={isLoading} />
    </Fragment>
    
  );
};

ModalPop.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  headerClassName: PropTypes.string,
  titleClassName: PropTypes.string,
};

export default ModalPop;
